import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { failedResponses } from '../errors/responses';

const c = initContract();

export const Address = z.object({
  id: z.string(),
  name: z.string(),
  line1: z.string(),
  line2: z.string().optional(),
  city: z.string(),
  state: z.string().optional(),
  country: z.string().optional(),
  postcode: z.string()
});

export type Address = z.infer<typeof Address>;

export const AddressResponse = Address.merge(
  z.object({
    id: z.string()
  })
);

export default c.router({
  getAddress: {
    method: 'GET',
    path: '/addresses/:id',
    responses: {
      200: AddressResponse,
      ...failedResponses
    }
  },
  postAddress: {
    method: 'POST',
    path: '/addresses',
    responses: {
      200: AddressResponse,
      ...failedResponses
    },
    body: Address.omit({ id: true })
  },
  deleteContact: {
    method: 'DELETE',
    path: '/addresses/:id',
    responses: {
      200: z.undefined(),
      ...failedResponses
    },
    body: z.undefined()
  },
  updateAddress: {
    method: 'PUT',
    path: '/addresses/:id',
    responses: {
      200: AddressResponse,
      ...failedResponses
    },
    body: Address.omit({ id: true })
  }
});
